import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers'
import { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: '9fr 4fr',
    // hide the picker for second input.
    // I tried removing KeyboardTimePicker and just using a text input, but it broke the whole component and the validation in many unexpected ways
    '& .MuiFormControl-root:nth-child(2) .MuiInputAdornment-positionEnd': {
      display: 'none'
    }
  }
})

export const DateTimePicker = ({
  input: { onChange, name },
  meta: { initial },
  labelDate,
  labelTime,
  ...rest
}) => {
  const classes = useStyles()

  const [date, setDate] = useState(initial ? new Date(initial) : new Date())
  const [time, setTime] = useState(initial ? new Date(initial) : new Date())

  const getDateString = (date) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1 // Jan is 0, dec is 11
    const day = date.getDate()
    return '' + year + '-' + month + '-' + day
  }

  const getTimeString = (date) => {
    return date.getHours() + ':' + date.getMinutes() + ':00'
  }

  const onChangeDate = (d) => {
    setDate(d)
    if (d && time) {
      const timeString = getTimeString(time)
      const dateString = getDateString(d)

      const newDate = new Date(dateString + ' ' + timeString)
      onChange(newDate)
    }
  }

  const onChangeTime = (t) => {
    setTime(t)
    if (t && date) {
      const timeString = getTimeString(t)
      const dateString = getDateString(date)

      const newDate = new Date(dateString + ' ' + timeString)
      onChange(newDate)
    }
  }

  return (
    <div className={classes.container}>
      <KeyboardDatePicker
        {...rest}
        autoOk
        variant="inline"
        label={labelDate}
        format="dd-MM-yyyy"
        invalidDateMessage="Ongeldige datum (gebruik dag-maand-jaar)"
        value={date}
        // @ts-ignore
        initial={initial}
        name={name}
        onChange={onChangeDate}
      />
      <KeyboardTimePicker
        {...rest}
        autoOk
        variant="inline"
        format="HH:mm"
        label={labelTime}
        invalidDateMessage="Ongeldige tijd (gebruik HH:mm)"
        value={time}
        // @ts-ignore
        initial={initial}
        name={name}
        onChange={onChangeTime}
      />
    </div>
  )
}
